











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFooterTeamAssignee_task",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskFooterTeamAssigneeMenu_task"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node ).hash = "31389176d5b50e7fe98f082fd332f719";

export default node;
